/* Small, finite enhancements. Existing motion.js remains the preference owner. */
(() => {
  'use strict';
  function start() {
    const root = document.documentElement;
    if (root.dataset.v6MotionReady) return;
    root.dataset.v6MotionReady = 'true';
    const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
    const running = new Map();
    let feedbackFrame = 0;
    const permitted = () => root.dataset.motion === 'active' && !preference.matches && !document.hidden;

    function stop(node) {
      const task = running.get(node);
      if (!task) return;
      window.clearTimeout(task.timer);
      node.classList.remove(task.className);
      node.removeEventListener('animationend', task.finish);
      running.delete(node);
    }
    function stopAll() {
      if (feedbackFrame) window.cancelAnimationFrame(feedbackFrame);
      feedbackFrame = 0;
      [...running.keys()].forEach(stop);
    }
    function play(node, className) {
      if (!node || !permitted() || running.has(node)) return;
      const finish = event => { if (event.target === node) stop(node); };
      const timer = window.setTimeout(() => stop(node), 1100);
      running.set(node, { className, finish, timer });
      node.addEventListener('animationend', finish);
      node.classList.add(className);
    }

    // Public hooks can also be placed on new V6 components. Nothing is hidden.
    const illustrations = '.r5-hero__art, .r5-story-door > figure, .r-brew-teaser > figure, [data-v6-enter="illustration"]';
    const chapters = '.r-story-chapter > figure, .r-note__index, [data-v6-enter="chapter"]';
    const seen = new WeakSet();
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting || seen.has(entry.target)) return;
          seen.add(entry.target);
          observer.unobserve(entry.target);
          // Do not replay chapters encountered while the reader has paused motion.
          if (entry.target.matches(illustrations)) play(entry.target, 'v6-illustration-enter');
          else play(entry.target, 'v6-chapter-enter');
        });
      }, { threshold: 0.18, rootMargin: '0px 0px -18px 0px' });
      document.querySelectorAll(`${illustrations}, ${chapters}`).forEach(node => {
        if (!node.hasAttribute('data-reveal')) observer.observe(node);
      });
    }

    function feedback(findNode) {
      if (feedbackFrame) window.cancelAnimationFrame(feedbackFrame);
      feedbackFrame = 0;
      if (!permitted()) return;
      feedbackFrame = window.requestAnimationFrame(() => {
        feedbackFrame = 0;
        play(findNode(), 'v6-feedback-enter');
      });
    }
    document.addEventListener('click', event => {
      // The existing guide updates its DOM before this bubbling listener runs.
      if (event.target.closest('[data-x-choice], [data-x-action]')) {
        feedback(() => document.querySelector('#x-cup-panel > :first-child'));
      }
    });
    window.addEventListener('hg:interaction', event => {
      if (event.detail?.event !== 'brew_guide_select') return;
      const topic = event.detail.topic;
      if (!['chai', 'coffee', 'cold'].includes(topic)) return;
      feedback(() => document.querySelector(`#x-panel-${topic} .x-lesson-art`));
    });
    const preferenceChanged = () => { if (!permitted()) stopAll(); };
    if (typeof preference.addEventListener === 'function') preference.addEventListener('change', preferenceChanged);
    else if (typeof preference.addListener === 'function') preference.addListener(preferenceChanged);
    if ('MutationObserver' in window) {
      new MutationObserver(preferenceChanged).observe(root, { attributes: true, attributeFilter: ['data-motion'] });
    }
    document.addEventListener('visibilitychange', preferenceChanged);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
